import createIcon from '../../createIcon';

/**
 * @component @name Thunderstorm
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuOTIgNi4wMkMxNy40NSAzLjE4IDE0Ljk3IDEgMTIgMUM5LjgyIDEgNy44MyAyLjE4IDYuNzggNC4wNkM0LjA5IDQuNDEgMiA2Ljc0IDIgOS41QzIgMTIuNTMgNC40NyAxNSA3LjUgMTVIMTcuNUMxOS45OCAxNSAyMiAxMi45OCAyMiAxMC41QzIyIDguMTYgMjAuMjEgNi4yMyAxNy45MiA2LjAyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjggMTZMMTEuOSAxOS4zMkwxMy45IDIwLjMyTDExLjU1IDIzSDE0LjJMMTcuMSAxOS42OEwxNS4xIDE4LjY4TDE3LjQ1IDE2SDE0LjhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC44IDE2TDUuOSAxOS4zMkw3LjkgMjAuMzJMNS41NSAyM0g4LjJMMTEuMSAxOS42OEw5LjEgMTguNjhMMTEuNDUgMTZIOC44WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Thunderstorm = createIcon('Thunderstorm', [
  [
    'path',
    {
      d: 'M17.92 6.02C17.45 3.18 14.97 1 12 1C9.82 1 7.83 2.18 6.78 4.06C4.09 4.41 2 6.74 2 9.5C2 12.53 4.47 15 7.5 15H17.5C19.98 15 22 12.98 22 10.5C22 8.16 20.21 6.23 17.92 6.02Z',
      key: 'km3zqu',
    },
  ],
  [
    'path',
    {
      d: 'M14.8 16L11.9 19.32L13.9 20.32L11.55 23H14.2L17.1 19.68L15.1 18.68L17.45 16H14.8Z',
      key: '1k8jjt',
    },
  ],
  [
    'path',
    {
      d: 'M8.8 16L5.9 19.32L7.9 20.32L5.55 23H8.2L11.1 19.68L9.1 18.68L11.45 16H8.8Z',
      key: '18iivq',
    },
  ],
]);

export default Thunderstorm;
